import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import SearchBar from "../components/SearchBar";
import JobCard from "../components/JobCard";
import { useAuth } from "../context/AuthContext";
import jobsData from "../data/jobs";
import "./Home.css";

// Hero Carousel Data
const heroCarouselData = [
  {
    id: 1,
    imgUrl:
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1470&q=80",
    title: "Find Your Dream Job",
    desc: "Thousands of opportunities waiting for you!",
  },
  {
    id: 2,
    imgUrl:
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1470&q=80",
    title: "Hiring Fast?",
    desc: "Post jobs and get instant applicants!",
  },
  {
    id: 3,
    imgUrl:
      "https://images.unsplash.com/photo-1635350736475-c8cef4b21906?w=600&auto=format&fit=crop&q=60",
    title: "Easy Apply",
    desc: "Apply to jobs with just one click!",
  },
];

// Feature Cards
const featureCards = [
  {
    id: 1,
    title: "Remote Jobs",
    desc: "Work from anywhere",
    images: [
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1470&q=80",
      "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1470&q=80",
    ],
  },
  {
    id: 2,
    title: "High Salary",
    desc: "Earn what you deserve",
    images: [
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1470&q=80",
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1470&q=80",
    ],
  },
];

// Popular Searches
const popularSearches = [
  { id: 1, title: "Jobs for Freshers", trendingAt: 1, imgUrl: "/jio.jpg" },
  { id: 2, title: "Work from home Jobs", trendingAt: 2, imgUrl: "/tcs.jpg" },
  { id: 3, title: "Part time Jobs", trendingAt: 3, imgUrl: "/reliance.jpg" },
  { id: 4, title: "Jobs for Women", trendingAt: 4, imgUrl: "/jobexpore.jpg" },
  { id: 5, title: "Full time Jobs", trendingAt: 5, imgUrl: "/kotak.jpg" },
];

// Trusted Companies
const trustedCompanies = [
  { id: 1, name: "Flipkart", logo: "/flipcard.png" },
  { id: 2, name: "GE", logo: "/ge.png" },
  { id: 3, name: "BigBasket", logo: "/bigbas.png" },
  { id: 4, name: "TATA", logo: "/tata.png" },
  { id: 5, name: "Swiggy", logo: "/swigge.png" },
  { id: 6, name: "Zomato", logo: "/zomato.png" },
  { id: 7, name: "TCS", logo: "/tcs.png" },
  { id: 8, name: "Groww", logo: "/groww.png" },
  { id: 9, name: "Zebronics", logo: "/zeb.png" },
  { id: 10, name: "IBM", logo: "/ibm.png" },
];

const Home = () => {
  const { user } = useAuth(); // logged in user
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [jobs, setJobs] = useState(jobsData);
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 6;
  const [showForm, setShowForm] = useState(false);

  const [newJob, setNewJob] = useState({
    title: "",
    company: "",
    location: "",
    type: "",
    salary: "",
    benefits: "",
    posted: "Just now",
  });

  // Post Job
  const handlePostJob = (e) => {
    e.preventDefault();
    const jobWithId = { ...newJob, id: jobs.length + 1 };
    setJobs([jobWithId, ...jobs]);
    setNewJob({
      title: "",
      company: "",
      location: "",
      type: "",
      salary: "",
      benefits: "",
      posted: "Just now",
    });
    setCurrentPage(1);
    setShowForm(false);
  };

  // Filter Jobs
  const filteredJobs = jobs.filter((job) => {
    const matchTitle = job.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchType =
      filterType === "" || job.type.toLowerCase() === filterType.toLowerCase();
    return matchTitle && matchType;
  });

  // Pagination
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home-page">
      {/* Hero Carousel */}
      <Carousel fade controls indicators className="hero-carousel">
        {heroCarouselData.map((slide) => (
          <Carousel.Item key={slide.id}>
            <img className="d-block w-100" src={slide.imgUrl} alt={slide.title} />
            <Carousel.Caption>
              <h3>{slide.title}</h3>
              <p>{slide.desc}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>

      <div className="container main-content my-5">
        <h1 className="text-center mb-4">Welcome to LadderUp</h1>

        {/* Logged In User */}
        {user && (
          <div className="alert alert-success text-center">
            👋 Hello <strong>{user.name}</strong> ({user.email})
          </div>
        )}

        {/* Trusted Companies */}
        <div className="trusted-marquee py-4 bg-light mb-5">
          <p className="text-center text-muted mb-3">
            Trusted by 1000+ enterprises and 7 lakh+ MSMEs for hiring
          </p>
          <div className="marquee-container">
            <div className="marquee-content">
              {trustedCompanies.concat(trustedCompanies).map((company, i) => (
                <img
                  key={i}
                  src={process.env.PUBLIC_URL + company.logo}
                  alt={company.name}
                  className="company-logo"
                />
              ))}
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="row feature-cards mb-5">
          {featureCards.map((card) => (
            <div className="col-md-6 mb-4" key={card.id}>
              <div className="feature-card">
                <Carousel fade interval={3000} controls={false}>
                  {card.images.map((img, i) => (
                    <Carousel.Item key={i}>
                      <img className="d-block w-100" src={img} alt={card.title} />
                    </Carousel.Item>
                  ))}
                </Carousel>
                <div className="feature-card-content p-3">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Popular Searches */}
        <div className="popular-searches mb-5">
          <h3 className="mb-3">Popular Searches on LadderUp</h3>
          <div className="row">
            {popularSearches.map((search) => (
              <div className="col-md-4 col-sm-6 mb-3" key={search.id}>
                <div className="card h-100">
                  <div style={{ height: "150px", overflow: "hidden" }}>
                    <img
                      src={process.env.PUBLIC_URL + search.imgUrl}
                      alt={search.title}
                      className="card-img-top h-100 w-100 object-fit-cover"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = process.env.PUBLIC_URL + "/logo192.png";
                      }}
                    />
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <small className="text-muted">
                          TRENDING AT #{search.trendingAt}
                        </small>
                        <h5 className="card-title mt-1">{search.title}</h5>
                      </div>
                      <button className="btn btn-sm btn-outline-primary">
                        View all &gt;
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Post Job */}
        <div className="text-end mb-4">
          <button
            className={`btn ${showForm ? "btn-danger" : "btn-primary"}`}
            onClick={() => setShowForm(!showForm)}
          >
            {showForm ? "✖ Cancel" : "➕ Post Job"}
          </button>
        </div>

        {showForm && (
          <div className="job-form mb-5">
            <h3>Post New Job</h3>
            <form onSubmit={handlePostJob}>
              <div className="row g-3">
                {["title", "company", "type", "salary", "location", "benefits"].map(
                  (field, i) => (
                    <div className="col-md-6" key={i}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                        value={newJob[field]}
                        onChange={(e) =>
                          setNewJob({ ...newJob, [field]: e.target.value })
                        }
                        required
                      />
                    </div>
                  )
                )}
                <div className="col-12">
                  <button type="submit" className="btn btn-success w-100">
                    Submit Job
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}

        {/* Search & Filter */}
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filterType={filterType}
          setFilterType={setFilterType}
          setCurrentPage={setCurrentPage}
        />

        {/* Job Listings */}
        {currentJobs.length > 0 ? (
          <div className="row job-listings">
            {currentJobs.map((job) => (
              <div key={job.id} className="col-md-6 col-lg-4 mb-4">
                <JobCard job={job} />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-5">
            <h4>⚠️ No jobs found</h4>
            <p>Try adjusting your search criteria</p>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <nav className="mt-4">
            <ul className="pagination justify-content-center">
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

export default Home;
